<template>
  <div class="home">
    <div class="top">
      <van-popup v-model="show" get-container="body" :style="{ height: '85%', width: '96%' }" :closeable="true">
        <div class="">
          <div class="plr20 bggrey ft28" style="height: 6vh; line-height: 6vh">
            列表
          </div>
          <div class="itme-wrapper" v-if="showbottleList.length">
            <div v-for="(item, index) in showbottleList" :key="index" style="padding: 0 0 10px; position: relative">
              <div class="items">
                <span class="item-name">登记单位：</span>
                <span class="item-value">{{ item.ownerDeptName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">气瓶编号：</span>
                <span class="item-value">{{ item.bottleId || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">填充介质：</span>
                <span class="item-value">{{ item.gasTypeName || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">入库时间：</span>
                <span class="item-value">{{ item.incomingTime || '-' }}</span>
              </div>
              <div class="items">
                <span class="item-name">出库时间：</span>
                <span class="item-value">{{ item.outcomingTime || '-' }}</span>
              </div>

            </div>
          </div>
          <div class="tc ptb10">
            <van-button type="danger" class="tc" @click="show = false">关闭</van-button>
          </div>
        </div>
      </van-popup>
      <div class="homes">
        <van-tabs v-model="active" @click="initContent" color="#4597ff">
          <van-tab title="出库操作">
            <div>
              <div class="modals bggrey">
                <van-form ref="appForm" @submit="onSubmit" @failed="failed" validate-trigger="onSubmit"
                  label-align="center" :scroll-to-error="true" :validate-first="true">
                  <div class="flex alcenter between">
                    <van-field :readonly="true" class="saomabe" 
                      v-model="appForm.ownerDeptName" @click="openPicker1('1')" label="登记单位" placeholder="请选择登记单位"
                      :required="true" :rules="[{ required: true, message: '请选择登记单位' }]" />
                  </div>

                  <div class="flex alcenter between">
                    <van-field label-align="center" :readonly="true" v-model="appForm.gasTypeName" @click="openPicker1('2')" label="填充介质"
                    placeholder="请选择填充介质" :required="true" :rules="[{ required: true, message: '请选择填充介质' }]" />
                  </div>

                  <div class="flex alcenter between">
                    <van-field label-align="center" type="number" label="出库个数" v-model="appForm.outcomingCount"
                      placeholder="请输入出库个数" :required="true" :rules="[{ required: true, message: '' }]" />
                    <div class="saoma" @click="scanQRcode">扫码出库</div>
                  </div>

                  <van-popup v-model="showPicker" round position="bottom" get-container="#app">
                    <van-picker title="请选择" item-height="7vh" show-toolbar :columns="columns" @confirm="pickerConfirm"
                      @cancel="pickerCancel" />
                  </van-popup>
                  <div class="colors">
                    <span>出库列表 (已出库：{{ appForm.bottleList.length }},剩余：{{ appForm.outcomingCount -
        appForm.bottleList.length }})</span>
                  </div>
                  <div class="pl30 ft28" style="height: 6.5vh !important; line-height: 6.5vh">
                    出库列表
                  </div>
                  <div class="itme-wrapper" v-if="appForm.bottleList.length">
                    <div v-for="(item, index) in appForm.bottleList" :key="index"
                      style="padding: 0 0 10px; position: relative">
                      <div class="items">
                        <span class="item-name">气瓶编号：</span>
                        <span class="item-value">{{ item.bottleId }}</span>
                      </div>
                      <div class="items">
                        <span class="item-name">入库年月：</span>
                        <span class="item-value">{{ item.lastCheckDate }}</span>
                      </div>
                      <van-button type="danger" size="small" class="delete-btn" native-type="button"
                        @click="deleteItem">删除</van-button>
                    </div>
                  </div>
                  <div style="position: fixed; bottom: 0" class="flex w100">
                    <van-button class="flex1 w47" style="border-right: 3px solid #fff" square @click="reset" block
                      type="info" native-type="button">重置</van-button>
                    <van-button class="flex1 w50" square block type="info" native-type="submit">出库</van-button>
                  </div>
                </van-form>
              </div>
            </div>
          </van-tab>
          <van-tab title="出库历史">
            <div>
              <van-pull-refresh class="bggrey" v-model="isLoading" @refresh="onRefresh">
                <div class="autoFixed">
                  <van-list v-model="loading" :finished="finishedBottom" finished-text="没有更多了" @load="onLoad">
                    <van-cell v-for="(item, index) in historyList" :key="index" style="margin-top: 20px; padding: 0">
                      <div class="main">
                        <div class="history-left" style="margin-top: 20px">
                          <div class="history-item">
                            <span>登记单位：</span>
                            <span>{{ item.ownerDeptName }}</span>
                          </div>
                          <div class="history-item">
                            <span>出库个数：</span>
                            <span>{{ item.outcomingCount || '-' }}</span>
                          </div>
                          <div class="history-item">
                            <span>出库时间：</span>
                            <span>{{ item.outcomingTime }}</span>
                          </div>

                        </div>
                        <van-button plain type="primary" size="small" class="userBtn1" @click="getDetail(item)">列表
                        </van-button>
                      </div>
                    </van-cell>
                  </van-list>
                </div>
              </van-pull-refresh>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import tabs from "@/components/tabs.vue";
import {
  outcomingAddApplyfor,
  queryOutcomingHistory,
  queryOutcomingDetail,
  bottleInfoQueryAll,
  queryGasType,
  getJsApi,
  queryBottle,//根据条码号查询气瓶信息
  queryOutcomingBottleByQrcode//根据二维码查询气瓶信息
} from "@/apis/api";
import { Toast, Dialog } from "vant";
export default {
  data() {
    return {
      historyList: [],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      isLoading: false,
      loading: false,
      finishedBottom: false,
      active: 0,
      showForm: {},
      showbottleList: [],
      appForm: {
        ownerDept: "", //登记单位id
        ownerDeptName: "", //登记单位名称
        gasType: "", //填充介质id
        gasTypeName: "", //填充介质名称
        outcomingCount: 0, //出库个数
        bottleList: [],
      },
      show: false,
      showPicker: false,
      picker_car: "",
      columns: [],
    };
  },
  mounted() {
    document.title = "气瓶出库";
    this.getSystemConfig()
  },
  methods: {
    getGasDetail(resultStr) {
      //根据条码号查询气瓶信息
      //queryBottle
      //根据二维码查询气瓶信息
      queryOutcomingBottleByQrcode({        
        //bottleNo: resultStr 
        qrcode: resultStr
      }).then(res => {
        if (res.code == 200) {
          let result = res.result;
          if (this.appForm.ownerDept && result.ownerDept !== this.appForm.ownerDept) {
            return this.$toast(`登记单位不符合，当前扫码气瓶登记单位为${result.ownerDeptName},请重新扫码`);
          }

          if (this.appForm.gasType && result.gasType !== this.appForm.gasType) {
            return this.$toast(`填充介质不符合,当前扫码气瓶填充介质为${result.gasTypeName},请重新扫码`);
          }
          //判断当前气瓶是否在列表中       
          for (let i = 0; i < this.appForm.bottleList.length; i++) {
            if (this.appForm.bottleList[i].bottleId === res.result.bottleId) {
              this.$toast(`该气瓶已存在，请勿重复添加`);
              return;
            }
          }
          this.appForm.bottleList.splice(0, 0, res.result)
          this.$set(this.appForm.bottleList, this.appForm.bottleList);
          if (this.appForm.bottleList.length == this.appForm.outcomingCount)   //出库数量等于气瓶总数
          {
            this.$toast("当前出库数量已达到最大值，请提交");
          }
        } else {
          this.$toast(res.message);
        }
      })
    },
    getSystemConfig() {
      console.log(encodeURI(location.href.split('#')[0]));
      getJsApi({
        curUrl: encodeURI(location.href.split('#')[0])
      }).then(res => {
        console.log(res.result);
        if (res.code == 200) {
          let configs = res.result
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: configs.appId, // 必填，公众号的唯一标识
            timestamp: configs.timestamp, // 必填，生成签名的时间戳
            nonceStr: configs.nonceStr, // 必填，生成签名的随机串
            signature: configs.signature,// 必填，签名
            jsApiList: ['scanQRCode'] // 必填，需要使用的JS接口列表
          });
          wx.ready((res) => {
            console.log('配置完成，扫码前准备完成')
          })
          wx.error(function (res) {
            console.log('出错了：' + res.errMsg);
          });
        } else {
          this.$toast(res.message);
        }
      }).catch(err => { })
    },
    //扫码
    scanQRcode() {
      if(this.appForm.outcomingCount <= 0)
      {
        this.$toast("填写的出库数量需要大于0");
        return
      }
      if (this.appForm.bottleList.length == this.appForm.outcomingCount)   //入库数量等于气瓶总数
      {
        this.$toast("当前出库数量已达到最大值，请提交");
        return
      }
      var ua = navigator.userAgent.toLowerCase()
      var isWeixin = ua.indexOf('micromessenger') !== -1
      if (!isWeixin) {
        alert('请用微信打开连接，才可使用扫一扫')
      }
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        //scanType: ["barCode"], // 条形码
        scanType: ["qrCode"], // 二维码
        success: (res) => {
          console.log(res);
          //根据条码号查询气瓶信息
          //this.getGasDetail(res.resultStr.split(',')[1] || res.resultStr)
          //根据二维码查询气瓶信息
          this.getGasDetail(res.resultStr)
        },
        fail: (err) => {
          console.log(err);
        }
      });
    },
    getDetail(item) {
      this.show = true;
      // this.showForm = item;
      this.getOutDetailList(item.id)
    },
    getOutDetailList(id) {
      queryOutcomingDetail({
        applyforId: id
      }).then(res => {
        if (res.code == 200) {
          this.showbottleList = res.result
          // this.appForm.bottleList.push(res.result)
          // this.$set(this.appForm.bottleList, this.appForm.bottleList);
        } else {
          this.$toast(res.message);
        }
      })
    },
    //删除气瓶
    deleteItem(index, item) {
      Dialog.confirm({
        title: "提示",
        message: "确认删除该气瓶吗？",
      }).then(() => {
        if (this.appForm.bottleList.length >= 1) {
          this.appForm.bottleList.splice(index, 1);
        }
      }).catch(() => { });
    },
    // 打开picker弹窗
    openPicker1(code) {
      if (this.picker_car != code) this.getSysCategory(code);
      this.picker_car = code;
      this.showPicker = true;
    },
    // 选择picker弹窗确定
    pickerConfirm(e) {
      if (this.picker_car == "1") {
        this.appForm.ownerDept = e.id;
        this.appForm.ownerDeptName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.ownerDept == this.appForm.ownerDept;
        })
      }
      else if (this.picker_car == "2") {
        this.appForm.gasType = e.id;
        this.appForm.gasTypeName = e.text;
        this.appForm.bottleList = this.appForm.bottleList.filter((item) => {
          item.gasType == this.appForm.gasType;
        })
      } 
      this.showPicker = false;
    },
    // 选择picker弹窗取消
    pickerCancel() {
      this.showPicker = false;
    },
    //查询picker弹窗列表
    getSysCategory(code) {
      let api = "";
      if (code === "1") {
        api = bottleInfoQueryAll;
      }else if (code === "2") {
        api = queryGasType;
      }
      this.columns = []
      api().then((res) => {
        if (res.code == 200) {
          if (code === "1") {
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.text = i.deptName;
              });
            }
          }
          else if(code=="2"){
            if (res.result.length) {
              res.result.forEach((i, v) => {
                i.text = i.name;
              });
            }
          }
          this.columns = res.result;
        } else {
          this.$toast(res.message);
        }
      });
    },
    // 重置
    reset() {
      this.appForm = {
        ownerDept: "", //登记单位id
        ownerDeptName: "", //登记单位名称
        gasType: "", //填充介质id
        gasTypeName: "", //填充介质名称
        outcomingCount: 0, //出库个数
        bottleList: [],
      }
    },
    // 校验失败
    failed() { },
    // 提交出库
    onSubmit() {
      console.log(this.appForm);
      outcomingAddApplyfor(this.appForm).then((res) => {
        if (res.code == 200) {
          this.$toast(res.message || '提交成功');
          this.reset();
        } else {
          this.$toast(res.message || '提交失败');
        }
      });
    },
    // 获取历史
    getHistoryList() {
      this.onRefresh(1);
    },
    //历史列表
    onRefresh(index) {
      this.pageNo = 1;
      this.pageSize = 10;
      this.isLoading = true;
      queryOutcomingHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          if (index != 1) {
            Toast("刷新成功");
          }
          this.historyList = res.result.records;
          this.total = res.result.total;
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // 历史列表加载更多
    onLoad() {
      console.log("加载更多");
      if (this.isLoading) return;
      this.pageNo++;
      queryOutcomingHistory({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isLoading = false;
        this.loading = false;
        if (res.code == 200) {
          this.historyList = this.historyList.concat(res.result.records);
          if (this.historyList.length == this.total) {
            this.finishedBottom = true;
          }
        } else {
          this.finishedBottom = true;
        }
      });
    },
    // tab点击
    initContent(value) {
      this.active = value;
      if (value == 0) {
        // 刷新页面
      } else {
        this.pageSize = 10;
        this.pageNo = 1;
        this.getHistoryList();
      }
    },
  },
  components: {
    tabs,
  },
};
</script>

<style lang="less" scoped>
@import url("./outbound.less");

.colors {
  color: #e80404;
  margin: 14px 0 0 40px;
}
</style>
